// components/Apps/FictionaryItem/FictionaryItem.js
import React from 'react';
import PropTypes from 'prop-types';

const partOfSpeechMap = {
  noun: 'Noun',
  verb: 'Verb',
  adj:  'Adjective',
  adv:  'Adverb',
  nm:   'Still life',
  ot:   'Other',
};

const FictionaryItem = ({ value }) => {
  const {
    pos,
    language,
    title,
    definition,
    motivation,
    example,
    synonyms = [],
  } = value;

  return (
    <div className="card card-data surface-pad-normal">
      <div className="block">

        {/* Header — title + badges */}
        <div className="block__header">
          <div className="cluster cluster-between">
            <div className="text-item-title">{title}</div>
            <div className="cluster cluster-tight">
              {pos && (
                <span className="fictionary-badge">
                  {partOfSpeechMap[pos] || pos}
                </span>
              )}
              {language && (
                <span className="fictionary-lang">{language}</span>
              )}
            </div>
          </div>
        </div>

        {/* Body — definition, motivation, example, synonyms */}
        <div className="block__body">
          <div className="stack stack-normal">

            {/* Definition */}
            <div className="stack stack-tight">
              <div className="text-label text-neutral-600">Definition</div>
              <div className="fictionary-entry">
                <div className="text-body">{definition}</div>
              </div>
            </div>

            {/* Motivation */}
            {motivation && (
              <div className="stack stack-tight">
                <div className="text-label text-neutral-600">Motivation</div>
                <div className="fictionary-entry">
                  <div className="text-body">{motivation}</div>
                </div>
              </div>
            )}

            {/* Example */}
            {example && (
              <div className="stack stack-tight">
                <div className="text-label text-neutral-600">Example</div>
                <div className="fictionary-entry fictionary-entry--quote">
                  <div className="text-body">{example}</div>
                </div>
              </div>
            )}

            {/* Synonyms */}
            {synonyms.length > 0 && (
              <div className="stack stack-tight">
                <div className="text-label text-neutral-600">Synonyms</div>
                <div className="fictionary-synonyms">
                  {synonyms.map((synonym, index) => (
                    <span key={index} className="fictionary-synonym">
                      {synonym}
                    </span>
                  ))}
                </div>
              </div>
            )}

          </div>
        </div>

      </div>
    </div>
  );
};

FictionaryItem.propTypes = {
  value: PropTypes.shape({
    pos:        PropTypes.string,
    language:   PropTypes.string,
    title:      PropTypes.string.isRequired,
    definition: PropTypes.string.isRequired,
    motivation: PropTypes.string,
    example:    PropTypes.string,
    synonyms:   PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};

export default FictionaryItem;